import BsTableColumnManager from './index.vue'
export default BsTableColumnManager